import { useGetMenuHeaderQuery } from '@/features/api/endpoints/LayoutEndpoints';
import { Button } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { Link } from 'react-router-dom';

const AskForStatsBtn = () => {
  const { t } = useTranslate();
  const { data } = useGetMenuHeaderQuery();

  if (
    !data ||
    data.statusAskForStats !== 'published' ||
    !data.askForStatsLink?.trim() ||
    !data.askForStatsType
  ) {
    return null;
  }

  const href = data.askForStatsLink.trim();

  if (data.askForStatsType === 'external_link') {
    return (
      <Button
        variant="filled"
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        color="#00b2b4"
        aria-label={t('header.ask_for_stats')}
      >
        {t('header.ask_for_stats')}
      </Button>
    );
  }

  if (data.askForStatsType === 'internal_link') {
    return (
      <Button
        variant="filled"
        component={Link}
        to={href}
        color="#00b2b4"
        aria-label={t('header.ask_for_stats')}
      >
        {t('header.ask_for_stats')}
      </Button>
    );
  }

  if (data.helpType === 'iframe') {
    return (
      <Button
        variant="filled"
        component={Link}
        to="statistics-request"
        color="#00b2b4"
        aria-label={t('header.ask_for_stats')}
      >
        {t('header.ask_for_stats')}
      </Button>
    );
  }

  return null;
};

export default AskForStatsBtn;
